import React, { Component } from "react";
import Tippy from "@tippyjs/react";
import 'tippy.js/dist/tippy.css';
import Twemoji from 'react-twemoji';
import AdminBoatForm from './AdminBoatForm.js';

class AdminBoatListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formOpen: false,
            formData: {}
        }

        this.switchForm = this.switchForm.bind(this);
        this.submitBoat = this.submitBoat.bind(this);
    }
    componentDidMount() {
        let serverUrl = 'http://localhost:9000/';
        if (process.env.NODE_ENV === 'development') serverUrl = 'http://localhost:9000/'
        else if (process.env.NODE_ENV === 'production') serverUrl = window.location.protocol + '//' + window.location.host + '/';
        this.setState({ serverUrl: serverUrl });
        // console.log(this.props.user)
    }
    render() {
        const boat = this.props.boat;

        const weatherSymbolUrl = 'https://openweathermap.org/img/wn/' + boat.weather.weather[0].icon + '@2x.png'
        const weatherDisplay = <img src={weatherSymbolUrl} className="weather-icon" alt={(boat.weather.weather[0].description.charAt(0).toUpperCase() + boat.weather.weather[0].description.slice(1))} />;
        const toolTipStyle = {
            fontSize: '0.8em'
        };
        const weatherName = boat.weather.weather[0].description.charAt(0).toUpperCase() + boat.weather.weather[0].description.slice(1);

        return (
            <>{
                this.state.formOpen ? <AdminBoatForm boat={this.state.formData} submitBoat={this.submitBoat} /> :
                    <li key={boat._id} className='boatListItem'>
                        <h2 className='boatName'>{boat.name} <span>{boat.type}</span> <Tippy content={(
                            <div>
                                <b>{weatherName}</b><br />
                                <span style={toolTipStyle} id="weatherTooltipEmoji">
                                    <Twemoji>🌡   {((boat.weather.main.temp - 273.15).toFixed(2))} °C</Twemoji>
                                    <Twemoji>🌀   {boat.weather.main.pressure} hPa</Twemoji>
                                    <Twemoji>💧   {boat.weather.main.humidity} %</Twemoji>
                                    <Twemoji>👁   {boat.weather.visibility} m</Twemoji>
                                    <Twemoji>☁   {boat.weather.clouds.all} %</Twemoji>
                                </span>
                            </div>
                        )} allowHTML='true' theme='custom' placement='auto'>
                            <span className='weather-display'>{weatherDisplay}</span>
                        </Tippy></h2>




                        <div className='boatInfo'><span>{boat.lat}</span>, <span>{boat.long}</span></div>
                        <div className="boatInfo"><span className="label">Speed : </span>{boat.speed}</div>
                        <div className="boatInfo"><span className="label">Beached : </span>{boat.onland ? 'true' : 'false'}</div>

                        <div className='boatInfo'><span className="label">Sails : </span>{boat.sails ? 'true' : 'false'}, <span className="label">Anchor : </span>{boat.anchor ? 'true' : 'false'}</div>
                        <div className="boatInfo"><span className="label">Bearing : </span>{boat.bearing}, <span className="label">Desired : </span>{boat.desiredBearing}</div>
                        <div className="boatInfo"><span className="label">Last Update : </span>{boat.lastUpdate}, <span className="label">Weather Update : </span>{boat.lastWeatherUpdate}</div>
                        <div className="boatInfo"><span className="label">Distance Total : </span>{boat.distanceTotal}</div>
                        <button className="boatInfo" onClick={this.switchForm}>Edit</button>
                    </li>
            }</>
        );
    }
    switchForm() {
        console.log('form', this.props.boat.name)
        if (this.state.formOpen) this.setState({ formOpen: false });
        else {
            this.setState({ formOpen: true, formData: structuredClone(this.props.boat) })

        }
    }
    submitBoat(values) {
        const oldValues = this.state.formData;
        let changedValues = {}
        changedValues._id = oldValues._id;

        if (oldValues.name != values.name) changedValues.name = values.name;
        if (oldValues.type != values.type) changedValues.type = values.type;
        if (oldValues.lat != values.lat) changedValues.lat = values.lat;
        if (oldValues.long != values.long) changedValues.long = values.long;
        if (oldValues.userId != values.userId) changedValues.userId = values.userId;

        console.log(changedValues)
        if (Object.keys(changedValues).length > 0) {
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(changedValues)
            }
            fetch(this.state.serverUrl + "admin/updateBoat", options)
                .then(res => res.json().then(json => {
                    if (json.message === 'success') {
                        this.setState({ formOpen: false })
                    }
                }));
        }
    }


}


export default AdminBoatListItem;
